import { useBasicInfoLinks } from "./useBasicInfoLinks";
import { useExceptionLinks } from "./useExceptionLinks";
import { useMainMenuLinks } from "./useMainMenuLinks";
import { usePayrollLinks } from "./usePayrollLinks";

export const useAppLinks = () => {
  const mainMenuLinks = useMainMenuLinks();
  const basicInfoLinks = useBasicInfoLinks();
  const exceptionLinks = useExceptionLinks();
  const payrollLinks = usePayrollLinks();

  return { mainMenuLinks, basicInfoLinks, exceptionLinks, payrollLinks };
};
